import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Grid, Container } from "@material-ui/core";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import careerClasses from './careersStyles';
import {FaArrowAltCircleRight, FaArrowAltCircleLeft } from 'react-icons/fa';
import {FiArrowLeftCircle, FiArrowRightCircle} from 'react-icons/fi';

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
     },

     stepIcon: {
        size: 100,
      },

     Stepper: {
      '&:hover': {
        textDecoration: 'underline',
      },
        "& $alternativeLabel": {
          padding: 200,
          '&:hover': {
            textDecoration: 'underline',
          },
        }
      },
      alternativeLabel: {

        
      }, 

    MuiButton: {
        root: {
            backgroundColor: '#a51416',
        },
        '&:hover': {
            background: 'transparent',
        },
    },

    buttonnext: {
      marginLeft: theme.spacing(1),
      color: "#B64C4C",
      fontSize: 28,
      "&:hover": {
        backgroundColor: "transparent",

      }
    },

    buttonprev: {
        marginRight: theme.spacing(1),
        color: "#B64C4C",
        fontSize: 28,
          "&:hover": {
          backgroundColor: "transparent",
        }
      },

    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      padding: 10,
    },
  }));

function getSteps() {
  return ['Initial Interview with hiring manager', 'Short project and team interview', 'Final interview with company leadership'];
}

function getStepContent(step) {
  switch (step) {
    case 0:
      return 'During the interview process, you may be given a short assignment to complete and present to a small panel of interviewers who represent a cross functional team. The assignment will be something reflective of the type of project work we do, and designed for us to gauge the process of how you work, more than the outcome. We’ll discuss your work, specifics about the job, and how you and your skill sets fit within our Pantheon culture.';
    case 1:
      return 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. ';
    case 2:
      return 'During the interview process, you may be given a short assignment to complete and present to a small panel of interviewers who represent a cross functional team. The assignment will be something reflective of the type of project work we do, and designed for us to gauge the process of how you work, more than the outcome. We’ll discuss your work, specifics about the job, and how you and your skill sets fit within our Pantheon culture.';
    default:
      return 'During the interview process, you may be given a short assignment to complete and present to a small panel of interviewers who represent a cross functional team. The assignment will be something reflective of the type of project work we do, and designed for us to gauge the process of how you work, more than the outcome. We’ll discuss your work, specifics about the job, and how you and your skill sets fit within our Pantheon culture.';
  }
}

export default function HorizontalNonLinearAlternativeLabelStepper() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed] = React.useState(new Set());
  const [skipped] = React.useState(new Set());
  const steps = getSteps();
  const careerStyles = careerClasses();

  const totalSteps = () => {
    return getSteps().length;
  };

 

  const skippedSteps = () => {
    return skipped.size;
  };

  const completedSteps = () => {
    return completed.size;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps() - skippedSteps();
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed
          // find the first step that has been completed
          steps.findIndex((step, i) => !completed.has(i))
        : activeStep + 1;

    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };



 

  function isStepComplete(step) {
    return completed.has(step);
  }

  return (
    <div className={classes.root}>
      <Stepper className={classes.stepPadding} classes={{
            alternativeLabel: classes.alternativeLabel
          }}
          alternativeLabel nonLinear activeStep={activeStep}
      >
          
        {steps.map((label, index) => {
          const stepProps = {};
          const buttonProps = {};
          return (
          
          <Step key={label} {...stepProps}
               StepIconProps={{
                    classes: { root: classes.stepIcon }
                  }}
          >
              <StepButton 
                onClick={handleStep(index)}
                completed={isStepComplete(index)}
                {...buttonProps}
                disableRipple
              >
                {label}
              </StepButton>
              
            </Step>
          );
        })}
        
      </Stepper>
      <div>
          <div style={{maxWidth: '100%', margin: '0 auto', textAlign: 'center'}}>
          <Container maxWidth={false} component="section">
        <Grid container >
        <Grid item xs={1} className={careerStyles.nextPrevArrows}>
          <Button disableRipple disabled={activeStep === 0} onClick={handleBack} className={classes.buttonprev}>
                <FiArrowLeftCircle />
              </Button>
              </Grid>
              <Grid item xs={10}>
              <Typography className={classes.instructions}>{getStepContent(activeStep)}</Typography>
              </Grid>
              <Grid item xs={1} className={careerStyles.nextPrevArrows}>
              <Button disableRipple disabled={activeStep === 2}
                onClick={handleNext}
                className={classes.buttonnext}
              >
                <FiArrowRightCircle/>
              </Button>
              </Grid>
       
            </Grid>
          </Container>  
          </div>
      </div>
    </div>
  );
}